module.exports = __webpack_public_path__ + "static/media/tick.0f793e77.png";